import React, { useEffect } from 'react'
import CustomLabel from 'designer/component/element/Label'
import {
  updateFieldValue,
  updateMapResponse,
  updateOnChange,
  updateWidgetData,
} from './DataControl'
import PropWrapper from './PropWrapper'

const Children = ({ dataProps }) => {
  const { props, fieldProps, fieldName, fieldKey, errors } = dataProps
  const { uischema, config } = props
  const { label } = uischema
  const { uiKey, value, renderWidget, mapResponse } = fieldProps

  const updateData = (value, isOnChange = false) => {
    updateFieldValue({ ...dataProps, value, isOnChange })
  }

  useEffect(() => {
    updateOnChange({ ...dataProps, value })
  }, [value])

  useEffect(() => {
    updateMapResponse(dataProps)
  }, [mapResponse])

  useEffect(() => {
    updateWidgetData(dataProps)
  }, [renderWidget])

  return (
    <CustomLabel
      fieldName={fieldName}
      fieldKey={fieldKey}
      label={label}
      uischema={uischema}
      value={value}
      uiKey={uiKey}
      updateData={updateData}
      errors={errors}
      config={config}
    />
  )
}

const LabelControl = (props) => {
  return (
    <PropWrapper {...props}>
      {({ dataProps }) => <Children dataProps={dataProps} />}
    </PropWrapper>
  )
}

export default LabelControl
